var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/plus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.700000, 1.700000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3,1.81188398e-13 C10.707841,1.81188398e-13 11.0444016,0.305188147 11.0937669,0.6996497 L11.1,0.8 L11.1,9.5 L19.8,9.5 C20.2418278,9.5 20.6,9.8581722 20.6,10.3 C20.6,10.707841 20.2948119,11.0444016 19.9003503,11.0937669 L19.8,11.1 L11.1,11.1 L11.1,19.8 C11.1,20.2418278 10.7418278,20.6 10.3,20.6 C9.89215895,20.6 9.55559842,20.2948119 9.50623314,19.9003503 L9.5,19.8 L9.5,11.1 L0.8,11.1 C0.3581722,11.1 1.81188398e-13,10.7418278 1.81188398e-13,10.3 C1.81188398e-13,9.89215895 0.305188147,9.55559842 0.6996497,9.50623314 L0.8,9.5 L9.5,9.5 L9.5,0.8 C9.5,0.3581722 9.8581722,1.81188398e-13 10.3,1.81188398e-13 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.88cff919.svg";
export { ForwardRef as ReactComponent };